import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  uid: null,
  name: '',
  avatar: '',
  favorites: [],
  selectedUser: null,
  watchlistMovies: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setWatchlist(state,action) {
      state.watchlistMovies = action.payload;
    },
    setFavorites(state,action) {
      state.favorites = action.payload;
    },
    setSelectedUser: (state,action) => {
      state.selectedUser = action.payload;
    },
    clearSelectedUser: (state) => {
      state.selectedUser = null;
    },
    setUserData(state,action) {
      const { user,favorites,unfinished } = action.payload;
      state.uid = user.id;
      state.name = user.dislayName;
      state.utente = user;
      state.favorites = favorites || [];
      state.watchlistMovies = unfinished || [];
    },
    addToWatchlist(state, action) {
      const video = action.payload;
      const exists = state.watchlistMovies.find(v => v.id === video.id);
      if (!exists) {
        state.watchlistMovies.push(video);
      }
    },
  },
});

export const { setSelectedUser,clearSelectedUser,setFavorites,setWatchlist,setUserData,addToWatchlist } = userSlice.actions;
export default userSlice.reducer;
